import type { FC, ReactNode } from "react";

import { cn } from "../../utils/general";
import { Button } from "../button";
import { ButtonGroup } from "../button-group";
import { CardHeader } from "../card";
import { Icon } from "../icon";
import { useEmailDraft } from "./email-draft-context";

export const EmailDraftHeader: FC<{ actions?: ReactNode }> = ({ actions }) => {
  const {
    title,
    placement,
    isMinimized,
    handleToggleMinimized,
    handleClose,
    closeLabel = "Close draft",
  } = useEmailDraft();
  const isInline = placement === "inline";

  return (
    <CardHeader className={cn("flex-0 pt-4 pb-2 pr-4", isMinimized && "py-2.5 pl-4 pr-2.5")}>
      <div className="flex items-center justify-between gap-2">
        <h3
          onClick={isInline ? undefined : handleToggleMinimized}
          className={cn("text-base font-semibold tracking-tight truncate", !isInline && "cursor-pointer")}
        >
          {title}
        </h3>

        <ButtonGroup className="gap-0 flex-shrink-0 flex-nowrap">
          {actions}
          {!isInline && (
            <>
              <Button
                variant="ghost"
                size="xs"
                onClick={handleToggleMinimized}
                aria-label={isMinimized ? "Expand draft" : "Minimize draft"}
              >
                <Icon icon={isMinimized ? "unfold_more" : "unfold_less"} />
              </Button>
              <Button variant="ghost" size="xs" onClick={handleClose} aria-label={closeLabel}>
                <Icon icon="close" />
              </Button>
            </>
          )}
        </ButtonGroup>
      </div>
    </CardHeader>
  );
};
